import React from 'react';
import * as Styles from '../Resources.styles';

const CardResource = ({ element }) => (
  <Styles.CardResourceSimple data-testid={`card-resource-simple-${element.title.replace(/\s+/g, '-').toLowerCase()}`} onClick={element.cta.onClick} size={element.size}>
    {element.icon && (
      <Styles.Image>
        <img src={element.icon} alt={element.name} />
      </Styles.Image>
    )}
    <Styles.CardSimpleTitle dangerouslySetInnerHTML={{ __html: element.title }} />
  </Styles.CardResourceSimple>
);

export default CardResource;
